import product1 from "../../images/product-1.jpg";
import product2 from "../../images/product-2.jpg";
import product3 from "../../images/product-3.jpg";
import sweet1 from "../../images/sweet3.jpg";
import sweet2 from "../../images/sweet-2.jpg";
import sweet3 from "../../images/sweet-3.jpg";

export const productData = [
  {
    img: product1,
    alt: "Pizza",
    name: "Supreme Pizza",
    desc:
      "Marinara sauce,basil,italian sausage,roma tomatoes,olives, and pesto",
    price: "₹449",
    button: "Add to Cart",
    link: "/Checkout1",
  },
  {
    img: product2,
    alt: "Pizza",
    name: "Hawaiian Paradise",
    desc: "Basil,schezwan sauce,onion,mozzarella cheese,red paprika",
    price: "₹599",
    button: "Add to Cart",
    link: "/Checkout2",
  },
  {
    img: product3,
    alt: "Pizza",
    name: "Veggie Overload",
    desc:
      "Sliced onions, sliced green capsicum, chopped mushrooms, olives and sweet corn.",
    price: "₹499",
    button: "Add to Cart",
    link: "/Checkout3",
  },
];

export const productDataTwo = [
  {
    img: sweet2,
    alt: "Donuts",
    name: "Doughlicious",
    desc:
      "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
    price: "₹199",
    button: "Add to Cart",
    link: "/Checkout4",
  },
  {
    img: sweet3,
    alt: "Ice Cream",
    name: "Caramel Wonder",
    desc:
      "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
    price: "₹149",
    button: "Add to Cart",
    link: "/Checkout5",
  },
  {
    img: sweet1,
    alt: "Brownie",
    name: "Brownie Bunch",
    desc:
      "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
    price: "₹119",
    button: "Add to Cart",
    link: "/Checkout6",
  },
];
